import { Pipe, PipeTransform } from '@angular/core';
import { MaskApplierService, MaskPipe } from 'ngx-mask';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private maskApplierService: MaskApplierService) {}
  // tslint:disable-next-line: no-any
  transform(value: number | string, args?: any): any {
    return new MaskPipe(this.maskApplierService).transform(value, '(000) 000-0000');
  }
}
